import React from "react";
import { DriverScores, BankRankings, ScenarioScores, AllScenarioWeights } from "../../../../api/apiTypes";
import TabellaAnalitica from "./table/TabellaAnalitica";
import TabellaPesi from "./table/TabellaPesi";
import TabelleClassifiche from "./table/TabelleClassifiche";
import TabelleScenari from "./table/TabelleScenari";
import TabellaDominioPunteggi from "./table/TabellaDominioPunteggi";

interface DataFromParent {
  reportId?: string;
  driverScores?: DriverScores;
  scenarioScores?: ScenarioScores;
  finalRanking?: BankRankings; 
  scenarioWeights?: AllScenarioWeights 
}

const ContainerCalcoloRanking: React.FC<DataFromParent> = ({
  driverScores,
  scenarioScores,
  finalRanking,
  scenarioWeights,
}) => {
  return (
    <div>
      <TabellaAnalitica driverScores={driverScores} />
      <TabellaDominioPunteggi />
      <TabelleScenari scenarioScores={scenarioScores} />
      <TabelleClassifiche finalRanking={finalRanking || {}} />
      {scenarioWeights && <TabellaPesi scenarioWeights={scenarioWeights} />}
      </div>
  );
};

export default ContainerCalcoloRanking;
